import React from 'react';
import classNames from 'classnames';
import './RadioButton.scss';
    
const RadioButton = (props) => {
    const labelClasses = classNames('rating__label', {
        'checked': props.isChecked
    });

    return (
        <label
            className={labelClasses}
            htmlFor={props.radioButtonId}
            title={props.ratingLabel}
        >
            {props.ratingLabel}
            <input
                checked={props.isChecked}
                className='rating__input'
                id={props.radioButtonId}
                name='rating'
                onChange={props.onChange}
                type='radio'
                value={props.value}
            />
        </label>
    );
};

export default RadioButton;



// WEBPACK FOOTER //
// ./application/components/RadioButton/RadioButton.jsx